export default __webpack_public_path__ + "static/media/Bloodseraph's Gauntlets.681158be.jpg";